@if (control!.touched &&
control!.hasError('required')) {
<small class="error-text">This field is required.</small>
}

@if (control!.touched &&
control!.hasError('email')) {
<small class="error-text">Email format is invalid.</small>
}

@if (control!.touched &&
control!.hasError('emailInUse')) {
<small class="error-text">Email already in use. To continue <span class="link sm" (click)="openLoginDialog()">Sign
    in</span></small>
}

@if(showKenitalaValidation) {

@if(control.value?.length > 0){
@if (control.value?.length < maxlength) { <small class="error-text">Kenitala should be 10 digits</small>
  }

  @else if (!containsOnlyDigits(control.value)) {
  <small class="error-text">Kenitala should contain only digits</small>
  }


  }
  }
